import { get } from 'lodash';

const styles = ({ color }) => ({
  contentContainer: {
    color: get(color, 'bodyText'),
    backgroundColor: get(color, 'white'),
    padding: "36px",
    marginLeft: "36px",
    marginRight: "36px",
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  headerText: {
    margin: "0 0 12px",
  },
  settingsForm: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "4px",
    gap: "24px",
    maxWidth: '850px',
  },
  fieldContainer: {
    margin: "0 !important",
  },
  textField: {
    paddingTop: '2px !important',
    paddingBottom: '0px !important',
  },
  notification: {
    left: 92,
  },
});
export default styles;
